export default __webpack_public_path__ + "static/media/instagram-icon.a0234c8b.svg";